import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeCopySource } from './file-type.copysource';
import { AzureDataLakeStoreFileDataset } from 'app/model/dataset/azure-data-lake-store.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStore.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureDataLakeStoreFileDataset) }
})
export class AzureDataLakeStoreFileCopySource extends FileTypeCopySource {
}
